export enum LOCALE_STORAGE_KEYS {
  SITES = 'sites',
  USER = 'user',
  ACTIVATED = 'activated',
  LEVELS = 'levels',
  CART_WIDGET_COLLAPSED = 'cartWidgetCollapsed',
  SELECTED_CONSULTATION_STAFF = 'selectedConsultationStaff',
  CURRENT_VIEW = 'currentView',
  SIDEBAR_VISIBLE = 'sidebarVisible',
  DRAW_COLOR = 'drawColor',
  PROCEDURE_COLOR_MAP = 'procedureColorMap',
  PIN_WIDTH = 'pinWidth',
  X_WIDTH = 'xWidth',
  LINE_WIDTH = 'lineWidth',
  INTAKE_LOCK = 'intakeLock',
}
